import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Anchor } from '@mantine/core';

function Link(props) {

  const {
    newTab,
    href,
    anchorProps,
    style,
    children
  } = props;

  const target = newTab ? '_blank' : '_self';

  return (
    <Anchor
      component={RouterLink}
      to={href}
      target={target}
      style={style}
      c='violet.8'
      fw={500}
      {...anchorProps}
    >
      {children}
    </Anchor>
  );

};

export default Link;